module.exports = __webpack_public_path__ + "img/add-circle.76d253bd.svg";